export enum BACKGROUND_POSITION_X_ENUM {
    left = 'left',
    right = 'right',
    center = 'center'
}
